<template>
	<div class="page-container">
        <div class="page-hero page-container">
            <div class="padding d-flex">
                <div class="page-title">
                    <h2 class="text-md text-highlight">{{ $t('dashboard.title') }}</h2>
                    <small class="text-muted">{{ $t('dashboard.tips') }}</small>
                </div>
                <div class="flex" style="text-align:right; margin-right: 5px">
                    
                </div>
                <div>
	                <div class="row mrg-0">
					</div>
                </div>
            </div>
        </div>
        <div class="page-content page-container" id="page-content">
        	<div class="padding" style="padding-top:0">
                <div class="row">
                    <!-- Area Chart -->
                    <div class="col-md-12 col-sm-12">
                        <Personal />
                    </div>
                    <div class="col-md-12 col-sm-12">
                        <Birthday :data="birthday" />
                    </div>
                    <div class="col-md-8 col-sm-12" v-if="userRole == 1">
                        <MonthlyOfferReport />
                    </div>
                    <div class="col-md-4 col-sm-12">
                        <BDRank />
                    </div>
                    <div class="col-md-12 col-sm-12">
                      <div style="text-align:right; margin-bottom:10px;">
                        <el-button type="primary" size="small" @click="createNew">{{ $t('meeting.add') }}</el-button>
                      </div>
                      <FullCalendar :options="calendarOptions" style="background-color:#ffffff" />
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal -->
        <el-dialog title="" 
          :visible.sync="showRoomBookingForm"
          width="70%"
          top="30px"
          :append-to-body="true">
                <div slot="title" class="header-title">
                  {{ $t('meeting.title') }}
                </div>
                <MeetingBookForm ref="meetingForm" :event="currentEvent" :users="users" @value-save="meetingBooked" />
                <div slot="footer" class="dialog-footer" v-if="currentEvent == null">
                    <el-button type="primary" @click="bookMeeting">{{ $t('meeting.save') }}</el-button>
              <el-button @click="showRoomBookingForm = false">{{ $t('meeting.close') }}</el-button>
          </div>
          <div slot="footer" class="dialog-footer" v-else>
                    <el-button type="primary" @click="updateMeeting">{{ $t('meeting.reschedule') }}</el-button>
                    <el-popover
              placement="top"
              width="200"
              v-model="delPop">
              <p>{{ $t('meeting.confirm') }}</p>
              <div style="text-align: right; margin: 0">
                <el-button size="mini" type="text" @click="delPop = false">{{ $t('meeting.b2') }}</el-button>
                <el-button type="primary" size="mini" @click="cancelMeeting">{{ $t('meeting.ok') }}</el-button>
              </div>
                <el-button type="info" slot="reference" style="margin-left:10px">{{ $t('meeting.cancel') }}</el-button>
              </el-popover>
              <el-button @click="showRoomBookingForm = false" style="margin-left:10px">{{ $t('meeting.close') }}</el-button>
          </div>
        </el-dialog>
    </div>
</template>
<style>
.chart-wrapper {
  height: 400px;
}
</style>
<script>
// @ is an alias to /src
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'

import MonthlyOfferReport from '@/components/dashboard/MonthlyOfferReport.vue'
import BDRank from '@/components/dashboard/BDRank.vue'
import Personal from '@/components/dashboard/Personal.vue'
import Birthday from '@/components/er/Birthday.vue'

import MeetingBookForm from '@/components/dashboard/MeetingBookForm.vue'

import moment from 'moment'

export default {
  name: 'Dashboard',
  props: ['users'],
  components: {
    MonthlyOfferReport,
    BDRank,
    Personal,
    FullCalendar,
    Birthday,
    MeetingBookForm
  },
  data: function() {
    return {
      companyOverview: null,
      showRoomBookingForm: false,
      currentEvent: null,
      delPop: false,
      birthday: [],
      calendarOptions: {
        plugins: [ dayGridPlugin, interactionPlugin ],
        headerToolbar: {
          left: 'prev,next',
          center: 'title',
          right: 'dayGridMonth,dayGridWeek,dayGridDay' // user can switch between the two
        },
        initialView: 'dayGridMonth',
        events: [
        ]
      },
      
    }
  },
  computed: {
    userRole: function() {
      return localStorage.getItem('role')
    }
  },
  methods: {
    createNew: function() {
      this.showRoomBookingForm = true
    },
    bookMeeting: function() {

    },
    meetingBooked: function() {

    },
    updateMeeting: function() {

    },
    cancelMeeting: function() {

    },
    loadBirthday: function() {
      let that = this
      this.$http.get(this.API_PREFIX + 'birthday/' + localStorage.getItem('token')).then(function (response) {
        that.birthday = response.data
      }).catch(function (error) {
        console.log(error)
      })
    },
    loadCompanyOverview: function() {
      let that = this
      this.$http.get(this.API_PREFIX + 'overview_report?userId=' + localStorage.getItem('token')).then(function (response) {
        that.companyOverview = response.data
      }).catch(function (error) {
        console.log(error)
      })
    },
    loadData: function() {
      //this.loadCompanyOverview()
      this.loadBirthday()
    }
  },
  created: function() {
    //console.log(this.users)
  },
  mounted: function() {
    this.loadData()
  }
}
</script>